import PropTypes from "prop-types"
import React from "react"

const PaymentMethodPanel = ({ paymentMethod }) => (
  <section className="rounded border border-gray-200 bg-white px-5 pb-5 pt-2">
    <h2 className="mb-3 text-lg font-semibold">Payment method</h2>
    {paymentMethod ? (
      <div className="flex flex-row">
        <div className="mr-4 flex items-center justify-center">
          <img
            src={paymentMethod.logo}
            alt="payment method brand logo"
            className="w-8"
          />
        </div>
        <div className="flex flex-col">
          <h5 className="m-0 text-sm font-semibold">{paymentMethod.title}</h5>
          <span className="text-xs text-gray-600">
            {paymentMethod.subtitle}
          </span>
        </div>
      </div>
    ) : (
      <p className="text-gray-600">No payment method on file.</p>
    )}
  </section>
)

PaymentMethodPanel.propTypes = {
  paymentMethod: PropTypes.shape({
    logo: PropTypes.string,
    title: PropTypes.string,
    subtitle: PropTypes.string,
  }),
}

export default PaymentMethodPanel
